import { cls } from "reactutils"
import QuestionIcon from "./QuestionIcon"

type SimpleTableProps = {
  renderinstruction: Array<any>
  tabledata: Array<any>
  width?: string | number
  header?: React.ReactNode
  onClickTip?: (_: any) => void
}

function SimpleTable({
  renderinstruction = [],
  tabledata = [],
  width = "100%",
  header = null,
  onClickTip = (_: any) => {},
}: SimpleTableProps) {
  return (
    <>
      <div
        className="table-container"
        style={{
          width: width,
        }}
      >
        {header}
        <div className="header">
          {renderinstruction.map((instruction, i) => (
            <div
              key={i}
              className={cls("header-column-item", instruction.className)}
              style={{
                width: instruction.width,
              }}
            >
              <div>
                {instruction.label}
                {instruction.tip && (
                  <QuestionIcon
                    onClick={() => onClickTip(instruction.tip)}
                    title={instruction.tip.content.map((t, i) => (
                      <div key={i}>{t}</div>
                    ))}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="body">
          {tabledata.map((row, dataIndex) => (
            <div className="row-item-container" key={dataIndex}>
              {renderinstruction.map((ins, i) => (
                <div
                  key={i}
                  className={cls("row-column-item", ins.className)}
                  style={{
                    width: ins.width,
                  }}
                >
                  <span
                    className={ins.oneline && "outline"}
                    title={(ins.renderFn && ins.renderFn(row)) || row[ins.key]}
                  >
                    {(ins.renderFn && ins.renderFn(row, dataIndex)) ||
                      row[ins.key]}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .table-container {
          font-size: 14px;
        }
        .row-column-item {
          display: inline-block;
          word-break: break-all;
          padding: 5px;
        }

        .row-item-container {
          display: flex;
        }

        .header {
          display: flex;
          background: #f6f6f6;
          border: 1px solid #eeeeee;
        }

        .header-column-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 38px;
          padding: 5px;
          justify-content: start;
          align-items: center;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }

        .row-column-item {
          border-bottom: 1px solid #e5e5e5;
          display: flex;
          justify-content: start;
          align-items: center;
          min-height: 38px;
          font-size: 12px;
        }

        .row-column-item .oneline {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .header .header-column-item:last-of-type {
          flex: 1 1 auto;
        }

        .row-item-container .row-column-item:last-of-type {
          flex: 1 1 auto;
        }

        .tip-item {
          font-size: 12px;
          position: relative;
          text-align: left;
        }

        .tip-item::before {
          font-size: inherit;
        }

        .tip-reference {
          cursor: pointer;
        }

        .tip-item-content {
          padding-left: 15px;
          display: inline-block;
        }

        .tip-item-content::before {
          content: "";
          width: 4px;
          height: 4px;
          background-color: #fff;
          border-radius: 50%;
          position: absolute;
          left: 7px;
          top: 7px;
        }
      `}</style>
    </>
  )
}

export default SimpleTable
